import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { customHistory } from "../../framework/customHistory";
import { IUserState } from "../../models/store/storeTypes";
import { Footer, INavigationCommand } from "./footer";

/* eslint-disable no-unused-vars */
export enum ActivePageType {
    Home = "0",
    Message = "1",
    InstantMessage = "2",
    Event = "3",
    Task = "4",
    Document = "5",
    FurtherEducation = "6",
    CalendarTask = "7",
}
/* eslint-enable no-unused-vars */

export interface INavigationBarProp {
    user: IUserState;
    activePage: ActivePageType;
}

export class NavigationBar extends React.Component<INavigationBarProp, {}> {
    handleNavigateToHome = () => {
        customHistory.push("/");
    };

    handleNavigateToMessages = () => {
        customHistory.push("/message");
    };

    handleNavigateToEvents = () => {
        customHistory.push("/event");
    };

    handleNavigateToTasks = () => {
        customHistory.push("/task");
    };

    handleNavigateToDocuments = () => {
        customHistory.push("/document");
    };

    handleNavigateToInstantMessages = () => {
        customHistory.push("/instantmessage");
    };

    handleNavigateToFurtherEducations = () => {
        customHistory.push("/userfurthereducation");
    };

    handleNavigateToCalendarTasks = () => {
        customHistory.push("/calendartask");
    };

    render() {
        const props = this.props;
        const commands: INavigationCommand[] = [];
        if (props.user?.canUseInstantMessages) {
            commands.push({
                id: "instantMessages",
                title: Translations.InstantMessagesMenuTitle,
                tooltip: Translations.InstantMessagesMenuTitle,
                classes: "instantMessage",
                active: props.activePage === ActivePageType.InstantMessage,
                onClick: this.handleNavigateToInstantMessages
            });
        }
        if (props.user?.canUseMessages) {
            commands.push({
                id: "currentTopics",
                title: Translations.CurrentTopicsAbbr,
                tooltip: Translations.CurrentTopics,
                classes: "message mui",
                active: props.activePage === ActivePageType.Message,
                onClick: this.handleNavigateToMessages
            });
        }
        if (props.user?.canUseEvents) {
            commands.push({
                id: "events",
                title: Translations.Events,
                tooltip: Translations.Events,
                classes: "event mui",
                active: props.activePage === ActivePageType.Event,
                onClick: this.handleNavigateToEvents
            });
        }
        if (props.user?.canUseTasks) {
            commands.push({
                id: "tasks",
                title: Translations.Tasks,
                tooltip: Translations.Tasks,
                classes: "task mui",
                active: props.activePage === ActivePageType.Task,
                onClick: this.handleNavigateToTasks
            });
        }
        if (props.user?.canUseDocuments) {
            commands.push({
                id: "documents",
                title: Translations.Documents,
                tooltip: Translations.Documents,
                classes: "document mui",
                active: props.activePage === ActivePageType.Document,
                onClick: this.handleNavigateToDocuments
            });
        }
        return (
            <Footer
                commands={commands}
            />
        );
    }
}